import { Country } from '@afterpaytouch/portal-api/types'

export const ACCEPTABLE_PASSWORD_STRENGTH = 2

export enum TwoFactorChallengeType {
  PHONE_NUMBER = 'PHONE_NUMBER',
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  CREDIT_CARD = 'CREDIT_CARD',
  LAST_NAME = 'LAST_NAME',
}

export interface PasswordResetTwoFactorChallenge {
  type: TwoFactorChallengeType
  hint: string
}

export enum AuthCheckCodeStatus {
  PASS = 'PASS',
  TWO_FACTOR_REQUIRED = 'TWO_FACTOR_REQUIRED',
}

export interface AuthCheckCodeResponse {
  status: AuthCheckCodeStatus
  challenges: PasswordResetTwoFactorChallenge[]
}

export interface AuthResetRequest {
  code?: string
  password: string
  'remember-me': boolean
}

export interface TwoFactorChallengeRequest {
  email: string
  code: number
  twoFactorChallenges: Partial<Record<TwoFactorChallengeType, string>>
  countryCode: Country
}

export enum AuthResetCodeError {
  PasswordResetCodeInvalid = 'password_reset_code_invalid',
  PasswordResetCodeMaxAttempts = 'password_reset_code_max_attempts',
  PasswordResetCodeGenerationNotAllowed = 'password_reset_code_generation_not_allowed',
}

export enum ResetError {
  IdenticalPassword = 'identical_password',
  WeakPassword = 'weak_password',
}

export interface VerifyChallengeFlow {
  checkChallenge: (email: string, code: number, twoFactorChallenges: Partial<Record<TwoFactorChallengeType, string>>, countryCode: Country) => Promise<void>
}
